module.exports = __webpack_public_path__ + "static/img/StudentRank1.42dc3c59.jpg";